// extracted by mini-css-extract-plugin
module.exports = {"speedDial":"NavBar_speedDial__3Kh7k"};